export function cloneData(data: any) {
    return JSON.parse(JSON.stringify(data));
}
